const Tokens = [
  {
    id: 0,
    title: "NFT Holders",
    percent: "70%",
    desc: "NFT Holders will earn $HHUT via p2e STAKING.",
  },
  {
    id: 1,
    title: "Liquidity",
    percent: "20%",
    desc: "20% of $HHUT token supply will be used for liquidity in exchanges.",
  },
  {
    id: 2,
    title: "Team",
    percent: "10%",
    desc: "10% of $HHUT token supply is for YOOBS team.",
  },
];

export default Tokens;
